import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import {
  type IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath.ts';
import { type IAsyncValueWidget } from '../async-value/IAsyncValueWidget.ts';
import { asyncSelectWidgetObjectName } from './hooks/asyncSelectObjectName.ts';
import { type IAsyncSelectWidget } from './IAsyncSelectWidget.ts';

export function getAsyncSelectOutputReferences(
  path: IReferencePath,
  widget: IAsyncSelectWidget | IAsyncValueWidget,
): IReference[] {
  // console.log(`widget.outputs`, widget.outputs);
  return (
    widget.outputs?.map(output => ({
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-${output.name}`,
      code: `${output.name}`,
      path: [
        ...path,
        {
          direction: ReferencePathDirection.Child,
          code: asyncSelectWidgetObjectName(widget.code),
        },
      ],
      field: output.type,
      label: `${widget.code}: ${output.sourcePath ?? output.name}`,
    })) ?? []
  );
}
